<svg xmlns="http://www.w3.org/2000/svg" width="8.121" height="14.121" viewBox="0 0 8.121 14.121">
  <path
    d="M 0.75757519,13.109568 6.7575751,7.1095678 0.75757519,1.1095684"
    style="fill: none; stroke: #b1b6ba; stroke-width: 1.5; stroke-linecap: round;"
  />
</svg>
